import React, {useEffect, useState} from 'react'
import {
    useMultiStyleConfig,
    VStack,
    Text,
    Flex,
    Button,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {ChevronRight} from '../../../components/icons'
import PropTypes from 'prop-types'
import CategoriesList from '../partials/categories-list'
import routingObject from '../../../utils/static-routes'
import {decodeHtmlEntities} from '../../../utils/utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import LoadingSpinner from '../../../components/loading-spinner'

const SearchResults = ({articles, setGoBackText, setPageTitle, setGoBackToPath, isLoading}) => {
    const styles = useMultiStyleConfig('Faq', {})
    const {articlesListStyles} = styles || {}
    const [visibleCount, setVisibleCount] = useState(5)
    const {locale} = useMultiSite()

    useEffect(() => {
        setGoBackText('default')
        setPageTitle('default')
        setGoBackToPath(routingObject.FAQ_PATH)
    }, [])

    const handleShowMore = () => {
        setVisibleCount((prevCount) => prevCount + 10)
    }

    const buildUrl = (articleName, articleId) => {
        let cleanName = decodeHtmlEntities(articleName)
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[?]/g, '')
        let url = `${routingObject.FAQ_PATH}/${cleanName}/a/${articleId}`
        return url
    }

    let content
    if (isLoading) {
        content = <LoadingSpinner />
    } else if (articles.length > 0) {
        content = (
            <>
                {articles.slice(0, visibleCount).map((article) => (
                    <Flex
                        {...articlesListStyles?.articleWrapper}
                        key={article?._source?.article_id}
                    >
                        <Flex {...articlesListStyles?.articleInnerContainer}>
                            <ChevronRight {...articlesListStyles?.chevronIcon} />
                            <Link
                                to={`/${locale?.alias}${buildUrl(
                                    article?._source?.category_name,
                                    article?._source?.article_id,
                                )}`}
                            >
                                <Text {...articlesListStyles?.articleLink}>
                                    {article?._source?.article_title}
                                </Text>
                            </Link>
                        </Flex>
                    </Flex>
                ))}
            </>
        )
    } else content = <CategoriesList />

    return (
        <VStack w="100%" h="100%" alignItems="flex-start">
            {content}
            <VStack {...articlesListStyles?.toogleCtaContainer}>
                {visibleCount < articles.length ? (
                    <Button {...articlesListStyles?.toogleCtaButton} onClick={handleShowMore}>
                        <Text {...articlesListStyles?.toogleText}>
                            <FormattedMessage
                                id="faq_page.article_list.cta_button.text"
                                defaultMessage="Show More"
                            />
                        </Text>
                    </Button>
                ) : (
                    <></>
                )}
            </VStack>
        </VStack>
    )
}

SearchResults.propTypes = {
    articles: PropTypes.array,
    setGoBackText: PropTypes.func,
    setPageTitle: PropTypes.func,
    setGoBackToPath: PropTypes.func,
    isLoading: PropTypes.bool,
}

export default SearchResults
